import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/scan-face.vue
var o = {
	name: "DtIconScanFace",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--scan-face"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Scan Face",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1A1.5 1.5 0 0 1 2.5 1h1a.5.5 0 0 1 0 1h-1ZM8 1.5a.5.5 0 0 1 .5-.5h1A1.5 1.5 0 0 1 11 2.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5ZM10.5 8a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 1 9.5 11h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5Zm-9 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 1 9.5v-1a.5.5 0 0 1 .5-.5Zm2.898-1.302A.5.5 0 0 0 3.6 7.3L4 7l-.4.3.001.001.001.002.004.005.01.014c.01.01.021.025.036.042a3.474 3.474 0 0 0 .585.54c.4.29 1 .596 1.763.596.763 0 1.364-.305 1.763-.596a3.473 3.473 0 0 0 .62-.582l.01-.014.005-.005v-.002H8.4L8 7l.4.3a.5.5 0 0 0-.798-.602l-.003.003a2.474 2.474 0 0 1-.425.395c-.288.21-.687.404-1.174.404-.487 0-.886-.194-1.175-.404a2.474 2.474 0 0 1-.424-.395l-.003-.003ZM4 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm3 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=scan-face.js.map